module.exports = __webpack_public_path__ + "img/item_link_packaging.f347f69.webp";